import { Box, Button, Container, Typography } from "@mui/material";
import GamesTable from "../../Games/GamesTable";
import { useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const RuleView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <Container maxWidth="lg" sx={{ py: 2, pt: 6 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          variant="contained"
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: 20, py: 2 }}>
          Games
        </Typography>
      </Box>

      <GamesTable status="" keyword="" ruleId={id} />
    </Container>
  );
};

export default RuleView;
